export default class DesignServicesVistaprintProxyService {
    /**
     * Perform a GET request to the Vistaprint Monolith via the DesignServicesProxy
     * @param {string} host
     * @param {string} endpoint 
     * @param {object} data
     */
    static async get(host, endpoint, data) {
        const uri = encodeURI(`/DesignServices/External/Get?host=${host}&endpoint=${endpoint}&data=${JSON.stringify(data)}`);

        return await fetch(uri, {
            method: 'GET',
            credentials: 'include', // send credential cookie with request
            headers: {
                'Accept': 'application/json',
            },
        });
    }

    static async post(host, endpoint, payload) {
        const uri = '/DesignServices/External/Post';

        return await fetch(uri, {
            method: 'POST',
            credentials: 'include', // send credential cookie with request
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Host: host,
                Endpoint: endpoint,
                JsonPayload: JSON.stringify(payload),
            }),
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/DesignServicesVistaprintProxyService.js